import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useViewerId from "@/api/user/use-viewer-id";
import { NormalizedRole } from "./types";

export default function useViewerRole(): NormalizedRole | null {
  const { data: viewerId } = useViewerId();
  const { data: currentShop } = useCurrentShopSuspense();
  const role = currentShop.users.find(
    (user) => user.userId === viewerId,
  )?.roleId;

  if (!role) return null;

  /**
   * In the old API, sometime, the roles are UpperCamelCase,
   * and sometimes snake_case. So we need to normalize them.
   */
  return role.toLowerCase().replace(/_/g, "") as NormalizedRole;
}
